


export const Footer = () => {
  return (

    <div className="footer">
      <span className="footer-right">Copyright © 2023 台灣公車 e 點通 All rights reserved.</span>
    </div>

  );
};
